// API
import BreedersAPI from "@/app/apis/main/breeders/breeders-api.js";

export default {
    /**
     * @param {*} breederDetails
     * @returns {Promise}
     */
    async registerBreeder(breederDetails) {
        return BreedersAPI.registerBreeder(breederDetails);
    },

    async registerUserAndBreeder(breederDetails) {
        return BreedersAPI.registerUserAndBreeder(breederDetails);
    },

    async getBreederById(userId) {
        return BreedersAPI.getBreederById(userId);
    },
    /**
     * Retrieves breeder details by user ID.
     *
     * @async
     * @function getBreederByUserId
     * @param {string} userId - The ID of the user whose breeder details are to be retrieved.
     * @returns {Promise<Object>} A promise that resolves to an object containing breeder details.
     * @throws {Error} If an error occurs while retrieving the breeder details.
    */
    async getBreederByUserId(userId) {
        return BreedersAPI.getBreederByUserId(userId);
    },

    async getBreederBioById(breederSysId) {
        return BreedersAPI.getBreederBioById(breederSysId);
    },

    async updateBreederDetails(details) {
        return BreedersAPI.updateBreederDetails(details);
    },

    async addBreederBio(details) {
        return BreedersAPI.addBreederBio(details);
    },
    async updateBreederBio(details) {
        return BreedersAPI.updateBreederBio(details);
    },

    async requestForReactivate(details) {
        return BreedersAPI.requestForReactivate(details);
    }
};
